/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Checkin_Call_Player_OnlineInputs */



/**
* | output |
* | --- |
* | "The organizer will check you in — make sure you've joined the server." |
*
* @param {Tournament_Checkin_Call_Player_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_checkin_call_player_online = /** @type {((inputs?: Tournament_Checkin_Call_Player_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Checkin_Call_Player_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'organisateur vous enregistrera — assurez-vous d'avoir rejoint le serveur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El organizador le hará el check-in — asegúrese de haberse unido al servidor.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O organizador fará seu check-in — certifique-se de ter entrado no servidor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'organizzatore farà il suo check-in — assicurarsi di essersi uniti al server.")
	return /** @type {LocalizedString} */ ("The organizer will check you in — make sure you've joined the server.")
});